import { createStyles } from '@mantine/core';

const useStyles = createStyles((theme) => ({
  container: {
    display: 'flex',
    flexFlow: 'column nowrap',
    alignItems: 'center',
    justifyContent: 'center',
    maxWidth: '420px',
    gap: /* eslint-disable-line local-rules/use-theme-tokens */ '24px',
    padding: /* eslint-disable-line local-rules/use-theme-tokens */ '24px 16px',
    minWidth: '100%',
  },
  textInput: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex',
    input: {
      backgroundColor: theme.colors.gray[1],
    },
  },
  iconContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '16px auto 0',
    backgroundColor: theme.colors.gray[1],
    borderRadius: '50%',
    width: 56,
    height: 56,
  },
  proveIconContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '16px auto 0',
    backgroundColor: theme.colors.gray[1],
    borderRadius: '50%',
    width: 96,
    height: 96,
  },
  titleContainer: {
    display: 'flex',
    minHeight: '20px',
    height: '20px',
    marginTop: /* eslint-disable-line local-rules/use-theme-tokens */ 5,
    alignItems: 'center',
  },
  introContainer: {
    display: 'flex',
    flexFlow: 'column nowrap',
    alignItems: 'center',
    justifyContent: 'center',
    gap: /* eslint-disable-line local-rules/use-theme-tokens */ '16px',
    width: '100%',
    minHeight: '100%',
  },
  formContainer: {
    display: 'flex',
    flexFlow: 'column nowrap',
    alignItems: 'center',
    gap: /* eslint-disable-line local-rules/use-theme-tokens */ '16px',
    width: '100%',
  },
  eoCalloutContainer: {
    marginTop: -theme.other.spacing._40,
  },
  headerContainer: {
    marginTop: theme.other.spacing._24,
    marginBottom: theme.other.spacing._32,
  },
  linkContainer: {
    marginTop: theme.other.spacing._64,
  },
  passwordInput: {
    input: {
      backgroundColor: theme.colors.gray[1],
    },
    '& .mantine-PasswordInput-rightSection': {
      backgroundColor: theme.colors.gray[1],
    },
  },

  legalContainer: {
    marginTop: theme.other.spacing._32,
    display: 'flex',
    flexFlow: 'column nowrap',
    alignItems: 'center',
    textAlign: 'center',
    gap: theme.other.spacing._24,
    width: '100%',
  },

  badge: {
    display: 'flex',
    alignItems: 'center',
    textAlign: 'center',
    justifyContent: 'center',
    paddingLeft: theme.other.spacing._6,
    paddingRight: theme.other.spacing._8,
    gap: theme.other.spacing._4,
    background: 'rgba(165, 245, 241)',
    borderRadius: /* eslint-disable-line local-rules/use-theme-tokens */ '100px',
    height: '20px',
    width: '78px',
    marginLeft: theme.other.spacing._8,
  },

  kycStartBadge: {
    display: 'flex',
    alignItems: 'center',
    textAlign: 'center',
    justifyContent: 'center',
    paddingLeft: theme.other.spacing._6,
    paddingRight: theme.other.spacing._8,
    gap: theme.other.spacing._4,
    background: theme.colors.blue[0],
    borderRadius: /* eslint-disable-line local-rules/use-theme-tokens */ '100px',
    height: '24px',
  },
  proveLogo: {
    fontSize: 14,
    fontWeight: 700,
    color: theme.colors.gray[6],
  },
  proveCard: {
    border: `1px solid ${theme.colors.gray[3]}`,
    borderRadius: theme.radius.md,
    padding: /* eslint-disable-line local-rules/use-theme-tokens */ '19px 16px',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.other.spacing._16,
    width: '100%',
    marginTop: theme.other.spacing._24,
  },
  proveCardHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
  },
  enterManuallyButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.other.spacing._4,
    background: 'none',
    border: 'none',
    padding: 0,
    cursor: 'pointer',
    width: '100%',
    marginTop: theme.other.spacing._24,
  },
  legalText: {
    fontSize: '12px',
    color: theme.colors.gray[6],

    '& a': {
      color: theme.colors.blue[5],
      fontWeight: 700,
      textDecoration: 'none',
    },
  },
  kycStartFieldGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.other.spacing._8,
    width: '100%',
  },
  divider: {
    width: '100%',
    paddingTop: /* eslint-disable-line local-rules/use-theme-tokens */ 3,
    paddingBottom: /* eslint-disable-line local-rules/use-theme-tokens */ 3,
  },
  radioGroupGrid: {
    display: 'grid',
    gap: theme.other.spacing._12,
  },
  emailVerificationContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    width: 480,
    maxWidth: '100%',
    padding: theme.other.spacing._24,
    gap: theme.other.spacing._16,
  },
  startOverButton: {
    background: 'none',
    border: 'none',
    padding: 0,
    cursor: 'pointer',
    alignSelf: 'flex-start',
  },
  pinInputSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.other.spacing._8,
    width: '100%',
  },
  pinInputWrapper: {
    position: 'relative',
    width: '100%',
    height: 69,
    backgroundColor: theme.colors.gray[1],
    border: `1px solid ${theme.colors.gray[3]}`,
    borderRadius: theme.radius.md,
    cursor: 'text',
  },
  pinInputWrapperError: {
    border: `1px solid ${theme.colors.red[4]}`,
  },
  codeInput: {
    position: 'absolute',
    inset: 0,
    width: '100%',
    height: '100%',
    padding: theme.other.spacing._16,
    background: 'transparent',
    border: 'none',
    borderRadius: theme.radius.md,
    fontSize: 20,
    fontWeight: 700,
    fontFamily: 'inherit',
    color: 'transparent',
    caretColor: 'transparent',
    outline: 'none',
  },
  codeDisplay: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.other.spacing._8,
    height: '100%',
    pointerEvents: 'none',
  },
  codeChar: {
    fontSize: 20,
    fontWeight: 700,
    lineHeight: '24px',
    letterSpacing: '-0.02em',
  },
  codeCharEmpty: {
    color: theme.colors.gray[4],
  },
  codeCharFilled: {
    color: theme.colors.gray2[7],
  },
  codeCharSuccess: {
    color: theme.colors.blue[3],
  },
  pinInputStatus: {
    position: 'absolute',
    right: 16,
    top: '50%',
    transform: 'translateY(-50%)',
    display: 'flex',
    alignItems: 'center',
    pointerEvents: 'none',
  },
  countdownText: {
    textAlign: 'left',
    width: '100%',
  },
  buttonsSection: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
  },
  resendButton: {
    marginTop: theme.other.spacing._16,
    color: theme.colors.blue[3],
    fontSize: 14,
    fontWeight: 700,
    lineHeight: '20px',
    '&:disabled': {
      color: theme.colors.blue[3],
    },
  },
  confirmInfoCardOuter: {
    borderRadius: theme.radius.lg,
    boxShadow: '0px 8px 40px 0px rgba(0,0,0,0.2)',
    padding: theme.other.spacing._12,
    width: '100%',
    background: `radial-gradient(ellipse at center, #FFFFFF, ${theme.colors.gray[1]})`,
  },
  confirmInfoCardInner: {
    position: 'relative',
    border: `1.5px dashed ${theme.colors.gray[3]}`,
    borderRadius: theme.radius.md,
    backgroundColor: 'rgba(255,255,255,0.7)',
    padding: /* eslint-disable-line local-rules/use-theme-tokens */ '24px 16px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.other.spacing._12,
  },
  confirmInfoEditButton: {
    position: 'absolute',
    top: 16,
    right: 16,
    background: 'none',
    border: 'none',
    padding: 0,
    cursor: 'pointer',
    color: theme.colors.blue[5],
    fontWeight: 600,
    fontSize: 14,
    lineHeight: '22px',
    fontFamily: 'inherit',
  },
  confirmInfoDetails: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.other.spacing._8,
    textAlign: 'center',
    width: '100%',
    whiteSpace: 'pre-line',
  },
  confirmInfoAvatar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: theme.colors.gray[1],
    borderRadius: '50%',
    width: 56,
    height: 56,
  },
  confirmInfoSecurityNote: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.other.spacing._8,
    width: '100%',
    paddingLeft: /* eslint-disable-line local-rules/use-theme-tokens */ 20,
    paddingRight: /* eslint-disable-line local-rules/use-theme-tokens */ 20,
  },
  kycDetailsFooter: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.other.spacing._16,
    width: '100%',
    marginTop: theme.other.spacing._24,
  },
  proveCodeDisplay: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.other.spacing._12,
    height: '100%',
    pointerEvents: 'none',
  },
  proveCodeChar: {
    fontSize: 36,
    fontWeight: 700,
    lineHeight: '40px',
    letterSpacing: '-0.02em',
  },
  proveResendButton: {
    background: 'none',
    border: 'none',
    padding: 0,
    cursor: 'pointer',
    color: theme.colors.blue[5],
    fontSize: 16,
    fontWeight: 500,
    lineHeight: '24px',
    fontFamily: 'inherit',
  },
}));

export default useStyles;
